<template>
  <div class="Content">

    <app-leftcolumn>
      <left-menu></left-menu>
    </app-leftcolumn>

    <div class="bloc-center-row">
      <app-centercolumn>
        <router-view></router-view>
      </app-centercolumn>

      <app-widgetcentercolumn>
      </app-widgetcentercolumn>
    </div>

    <app-rightcolumn>
    </app-rightcolumn>

  </div>
</template>

<script>
  // placeholders components
  import AppLeftcolumn from '../columns/Leftcolumn.vue'
  import AppCentercolumn from '../columns/Centercolumn.vue'
  import AppWidgetcentercolumn from '../columns/WidgetCentercolumn.vue'
  import AppRightcolumn from '../columns/Rightcolumn.vue'

  import LeftMenu from '../menu/LeftMenu.vue'
  import UsersList from '../users/UsersList.vue'

  export default{
    components: {
      AppLeftcolumn, AppCentercolumn, AppWidgetcentercolumn, AppRightcolumn,
      LeftMenu, UsersList
    }
  }
</script>



// WEBPACK FOOTER //
// AdministrationView.vue?20611164